import { render, staticRenderFns } from "./HomeworkAnswers.vue?vue&type=template&id=257428f2"
import script from "./HomeworkAnswers.vue?vue&type=script&lang=js"
export * from "./HomeworkAnswers.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/buildhome/repo/CoreProductivity.Backoffice.Mobile/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('257428f2')) {
      api.createRecord('257428f2', component.options)
    } else {
      api.reload('257428f2', component.options)
    }
    module.hot.accept("./HomeworkAnswers.vue?vue&type=template&id=257428f2", function () {
      api.rerender('257428f2', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/view/pages/homework/HomeworkAnswers.vue"
export default component.exports